export default __webpack_public_path__ + "static/media/menu-svgrepo-com.dbc242a5.svg";